import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-line-of-business',
  templateUrl: './line-of-business.component.html',
  styleUrls: ['./line-of-business.component.scss']
})
export class LineOfBusinessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
